<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.verAddCon{
    position: relative;
    .title{
        font-size: 20px;
        padding: 4px 0 20px;
    }
    .colseButton{
        position: absolute;
        right: -18px;
        top:-18px
    }
}
</style>

<template>
<div class="verAddCon"  v-if='showModel'>
        <div class="title">{{$t('accountRecharge.addButton')}}</div>
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
           
            <FormItem :label="$t('accountRecharge.titleName.transAmount')" prop="transAmount" style="width: 500px">
                <InputNumber :active-change="false" :min="1"  :step="1" :precision='2' v-model="formData.transAmount" :placeholder="$t('inputPlaceholder')" ></InputNumber>
            </FormItem>

            <FormItem :label="$t('accountRecharge.titleName.remark')" prop="remark" style="width: 500px">
                <Input  maxlength="100" show-word-limit type="textarea" v-model.trim="formData.remark"  :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
          
        </Form>

</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState } from 'vuex'

    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            offModel: Boolean
        },
        name: "ModelPlan",
        components: {
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                releaseGroupName:'',
                formData: {//表单数据
                    type:'1',
                    transAmount:1,
                    remark:''
                }, 
               
            }
        },
        watch:{
            showModel(val){
                if(val === true) {   
                   
                  
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                    
                }
            },
        },
        computed:{
            ...mapState(['local','selectId']),
             ruleCustom(){
                 return {//验证
                    transAmount: [
                        {required: true, type:'number', message: this.$t('required'),trigger: 'blur' },
                    ],
                    remark: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    
                }
             } 

        },
        created(){
           
        },
        methods: {
           
            subData(name) {//提交表单
                if(!this.formData.transAmount){
                   return
                }
               
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        let url = this.config.urlArray.translogAdd
                        this.axios.post(url,{...this.formData,dealerId:this.selectId}).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false})
                        
                        }).catch((err) => {
                            console.log(err)
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);
                this.formData.transAmount = 1
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>
